import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgCircleSuccess = (props, ref) => /* @__PURE__ */ jsxs("svg", { width: 48, height: 48, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: [
  /* @__PURE__ */ jsx("circle", { cx: 24, cy: 24, r: 23.5, fill: "#F1F5DE", stroke: "#82A041" }),
  /* @__PURE__ */ jsx("path", { d: "M16 24.604L21.2528 30L32 18.9598L30.1058 17.0001L21.2528 26.0945L17.8942 22.6581L16 24.604Z", fill: "#82A041" })
] });
const ForwardRef = forwardRef(SvgCircleSuccess);
export { ForwardRef as ReactComponent };
